import { entityTypeNameFor } from "@shapeable/utils";
// NOTE: I am unable to add the width property to the embed due to some parsing issue.
// markdown image width and height have been set on the CommentStyles in the Comment component.
export var createUploadEntityEmbedString = function (createdEntity) {
  var createImageAsset = createdEntity.createImageAsset,
    createFileAsset = createdEntity.createFileAsset;
  if (createImageAsset) {
    var type = entityTypeNameFor(createImageAsset);
    return "<".concat(type, " slug=\"").concat(createImageAsset.slug, "\" id=\"").concat(createImageAsset.id, "\" />");
  } else if (createFileAsset) {
    var type = entityTypeNameFor(createFileAsset);
    return "<".concat(type, " slug=\"").concat(createFileAsset.slug, "\" id=\"").concat(createFileAsset.id, "\" />");
  }
};